import * as React from 'react';

/* UTILS */
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        inputMode={type === 'number' ? 'numeric' : type === 'email' ? 'email' : 'text'}
        className={cn(
          'flex w-full h-14 rounded-sm border-input bg-[#F1F1F1] px-5 py-1 text-bodyLarge transition-colors file:border-0 file:bg-transparent file:text-bodyMedium file:text-foreground placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
